import {
  IonFab,
  IonFabButton,
  IonIcon,
  IonLabel,
  IonRouterContext,
  useIonViewDidEnter,
} from '@ionic/react';
import { addOutline } from 'ionicons/icons';
import { isNil } from 'lodash';
import { ReactElement, useCallback, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  FindRolesOptionsBaseRolesFilter,
  ListRolesInput,
  ListRolesQuery,
  Role,
  useListRolesQuery,
} from '../../api/graphql/generated';
import { InfiniteScrollOptions } from '../../api/hooks/infinite-scroll.hooks';
import { trackAccessedTenantUser } from '../../config/analytics';
import { useBeaconRouter } from '../../route/route.hooks';
import { IonItem } from '../ionic/IonItem';
import { ObjectList, RowRenderer } from '../object/object-list';
import { RoleDetailModal } from '../role/role-detail-modal';

const TenantRoles = (): ReactElement => {
  const { i18n } = useTranslation();
  useIonViewDidEnter(() => {
    trackAccessedTenantUser();
  }, []);

  const { builder } = useBeaconRouter();
  const { push } = useContext(IonRouterContext);

  const [isShowingCreateModal, setShowingCreateModal] =
    useState<boolean>(false);

  const rowRenderer = useCallback<RowRenderer<Role>>(
    ({ item: role }) => {
      return (
        <IonItem key={role.id} routerLink={builder.getAdminRoleRoute(role.id)}>
          <IonLabel className="ion-padding-start">
            <h2>{role.name}</h2>
          </IonLabel>
        </IonItem>
      );
    },
    [builder]
  );
  useListRolesQuery;

  const query: InfiniteScrollOptions<ListRolesQuery, ListRolesInput> = {
    useQuery: useListRolesQuery,
    input: {
      baseRolesFilter: FindRolesOptionsBaseRolesFilter.HIDE,
    },
    queryOptions: {
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-first',
    },
  };

  const onDidDismiss = useCallback(
    (role?: Role) => {
      setShowingCreateModal(false);
      if (!isNil(role)) {
        push(builder.getAdminRoleRoute(role.id));
      }
    },
    [push, builder]
  );

  return (
    <>
      <ObjectList
        query={query}
        noResults={i18n.t('common:no_roles_found')}
        rowRenderer={rowRenderer}
      />
      <IonFab vertical="bottom" horizontal="end" slot="fixed">
        <IonFabButton onClick={() => setShowingCreateModal(true)}>
          <IonIcon icon={addOutline} />
        </IonFabButton>
      </IonFab>
      <RoleDetailModal
        isOpen={isShowingCreateModal}
        onDidDismiss={onDidDismiss}
      />
    </>
  );
};

export { TenantRoles };
